export default __webpack_public_path__ + "static/media/cabourg12.3a6821ba.jpg";